import { DefaultRootState } from "react-redux";

import { createSelector } from "@reduxjs/toolkit";

import { FiltersState } from "@/store/reducers/filters";

export const getTagsSelector = createSelector(
  (state: DefaultRootState) => state.filters,
  ({ tags }: FiltersState) => tags,
);

export const getAvailableTagsSelector = createSelector(
  (state: DefaultRootState) => state.filters,
  ({ availableTags }: FiltersState) => availableTags,
);

export const isLoadingFilters = createSelector(
  (state: DefaultRootState) => state.filters,
  ({ loading }: FiltersState) => loading,
);

